import {
  TARGET_TYPE,
  type TargetTypeType,
} from '@terra/shared-schemas-orchestrator';

export type FindingsCreateChainAction = 'copilot';

export function resolveFindingsCreateChainAction({
  targetType,
  isNetworkFindingChainingEnabled,
  selectionMode,
  selectedCount,
}: {
  targetType: TargetTypeType | undefined;
  isNetworkFindingChainingEnabled: boolean;
  selectionMode: 'ids' | 'filter';
  selectedCount: number;
}): FindingsCreateChainAction | null {
  if (selectionMode !== 'ids' || selectedCount < 2) {
    return null;
  }

  if (targetType === TARGET_TYPE.WEB_APPLICATION) {
    return 'copilot';
  }

  if (
    targetType === TARGET_TYPE.EXTERNAL_NETWORK &&
    isNetworkFindingChainingEnabled
  ) {
    return 'copilot';
  }

  return null;
}
